class WishlistButton extends HTMLElement {}

customElements.define('wishlist-button', WishlistButton);

// -----------------------------------------------------------------------------
// WISHLIST: replace app popup with inline "Saved / View Wishlist" row on cards
// -----------------------------------------------------------------------------

(function () {
  var SAVED_ROW_CELEBRATION_MS = 3000;
  var forcedUnsavedUntilByCard = new WeakMap();
  /** After the celebration, show title/price/quick-add even though the app still reports wishlisted. */
  var normalInfoDespiteWishlist = new WeakSet();
  var celebrationUntilByCard = new WeakMap();
  var celebrationTimerByCard = new WeakMap();

  function markForcedUnsaved(card, ms) {
    if (!card) return;
    forcedUnsavedUntilByCard.set(card, Date.now() + (ms || 700));
  }

  function isForcedUnsaved(card) {
    if (!card) return false;
    var until = forcedUnsavedUntilByCard.get(card) || 0;
    if (!until) return false;
    if (Date.now() < until) return true;
    forcedUnsavedUntilByCard.delete(card);
    return false;
  }

  function clearSavedCelebration(card) {
    if (!card) return;
    var t = celebrationTimerByCard.get(card);
    if (t) clearTimeout(t);
    celebrationTimerByCard.delete(card);
    celebrationUntilByCard.delete(card);
  }

  function isCelebrationActive(card) {
    if (!card) return false;
    var until = celebrationUntilByCard.get(card) || 0;
    if (!until) return false;
    return Date.now() < until;
  }

  function isSaved(buttonEl) {
    if (!buttonEl) return false;
    return buttonEl.getAttribute('data-total') === '1' || buttonEl.dataset.added === 'true';
  }

  function rawWishlistSavedForCard(card) {
    if (!card) return false;
    var movedBtn = card.querySelector('.mosaic-card__saved-action .wishlist-engine');
    var inlineBtn = card.querySelector('.mosaic-card__wishlist-inline .wishlist-engine');
    var overlayBtn = card.querySelector('.mosaic-card__wishlist-overlay .wishlist-engine');

    if (window.matchMedia && window.matchMedia('(max-width: 999px)').matches) {
      if (overlayBtn) return isSaved(overlayBtn);
      return isSaved(movedBtn) || isSaved(inlineBtn);
    }

    if (movedBtn) return isSaved(movedBtn);
    if (inlineBtn) return isSaved(inlineBtn);
    return isSaved(overlayBtn);
  }

  function finishSavedRowCelebration(card) {
    if (!card) return;
    clearSavedCelebration(card);
    normalInfoDespiteWishlist.add(card);
    updateAllCards();
  }

  function startSavedRowCelebrationCountdown(card) {
    if (!card) return;
    clearSavedCelebration(card);
    var until = Date.now() + SAVED_ROW_CELEBRATION_MS;
    celebrationUntilByCard.set(card, until);
    var timer = setTimeout(function () {
      finishSavedRowCelebration(card);
    }, SAVED_ROW_CELEBRATION_MS);
    celebrationTimerByCard.set(card, timer);
    forcedUnsavedUntilByCard.delete(card);
  }

  /** Re-attach timeout if mobile / background throttling dropped it during an active add-to-wishlist celebration. */
  function restoreCelebrationTimerIfNeeded(card) {
    if (!card) return;
    if (normalInfoDespiteWishlist.has(card)) return;
    if (isForcedUnsaved(card)) return;
    var until = celebrationUntilByCard.get(card) || 0;
    var now = Date.now();
    if (until > now && !celebrationTimerByCard.has(card)) {
      var msLeft = until - now;
      var timer = setTimeout(function () {
        finishSavedRowCelebration(card);
      }, msLeft);
      celebrationTimerByCard.set(card, timer);
    }
  }

  /**
   * Wishlist state from page load / app hydration only G�� no "Saved" strip; same as post-celebration.
   * The 5s animation runs only after startSavedRowCelebrationCountdown (user adds in this session).
   */
  function treatHydratedWishlistAsNormalInfo(card) {
    if (!card) return;
    if (normalInfoDespiteWishlist.has(card)) return;
    if (isForcedUnsaved(card)) return;
    if (isCelebrationActive(card)) return;
    if (!rawWishlistSavedForCard(card)) return;
    normalInfoDespiteWishlist.add(card);
  }

  function getCardSavedState(card) {
    if (!card) return false;
    if (isForcedUnsaved(card)) return false;
    var untilSweep = celebrationUntilByCard.get(card) || 0;
    if (untilSweep && Date.now() >= untilSweep) {
      clearSavedCelebration(card);
      normalInfoDespiteWishlist.add(card);
    }
    if (normalInfoDespiteWishlist.has(card)) return false;
    if (isCelebrationActive(card)) return true;
    var movedBtn = card.querySelector('.mosaic-card__saved-action .wishlist-engine');
    var inlineBtn = card.querySelector('.mosaic-card__wishlist-inline .wishlist-engine');
    var overlayBtn = card.querySelector('.mosaic-card__wishlist-overlay .wishlist-engine');

    // Mobile interaction happens on the overlay icon.
    // Trust overlay state first so remove/add transitions stay accurate.
    if (window.matchMedia && window.matchMedia('(max-width: 999px)').matches) {
      if (overlayBtn) return isSaved(overlayBtn);
      return isSaved(movedBtn) || isSaved(inlineBtn);
    }

    // Desktop uses inline/saved-row control.
    if (movedBtn) return isSaved(movedBtn);
    if (inlineBtn) return isSaved(inlineBtn);
    return isSaved(overlayBtn);
  }

  function createSavedRow() {
    var row = document.createElement('div');
    row.className = 'mosaic-card__saved-row';
    row.setAttribute('aria-live', 'polite');
    row.innerHTML =
      '<span class="mosaic-card__saved-label">Saved</span>' +
      '<a href="/pages/wishlist" class="mosaic-card__saved-link">View Wishlist</a>' +
      '<span class="mosaic-card__saved-action"></span>';
    return row;
  }

  function ensureSavedRow(card) {
    if (!card) return null;
    var info = card.querySelector('.mosaic-card__info');
    if (!info) return null;
    var row = info.querySelector('.mosaic-card__saved-row');
    if (!row) {
      row = createSavedRow();
      info.insertBefore(row, info.firstChild);
    }
    return row;
  }

  function updateCard(card) {
    var row = ensureSavedRow(card);
    if (!row) return;
    restoreCelebrationTimerIfNeeded(card);
    treatHydratedWishlistAsNormalInfo(card);
    var saved = getCardSavedState(card);
    row.classList.toggle('is-visible', saved);
    card.classList.toggle('mosaic-card--saved', saved);

    var savedAction = row.querySelector('.mosaic-card__saved-action');
    var inlineWrap = card.querySelector('.mosaic-card__wishlist-inline');
    var inlineWishlist = card.querySelector('.mosaic-card__wishlist-inline .wishlist-engine');
    var savedWishlist = card.querySelector('.mosaic-card__saved-action .wishlist-engine');
    // Keep mobile overlay wishlist button in place; only move the inline one.
    var activeWishlist = savedWishlist || inlineWishlist;

    if (savedAction && inlineWrap && activeWishlist) {
      if (saved) {
        if (activeWishlist.parentElement !== savedAction) {
          savedAction.appendChild(activeWishlist);
        }
      } else {
        if (activeWishlist.parentElement !== inlineWrap) {
          inlineWrap.appendChild(activeWishlist);
        }
      }
    }
  }

  function updateAllCards() {
    document
      .querySelectorAll(
        '.collection-mosaic__item .mosaic-card, .cart-page-layout__reco-mosaic .mosaic-card, .vmx-wishlist-now .mosaic-card'
      )
      .forEach(updateCard);
  }

  function suppressWishlistPopupNode(node) {
    if (!node || node.nodeType !== 1) return;
    var text = (node.textContent || '').toLowerCase();
    if (text.includes('successfully added to wishlist') && text.includes('my wishlist')) {
      node.style.display = 'none';
      node.setAttribute('aria-hidden', 'true');
    }
  }

  /** SE wishlist host can use shadow DOM; composedPath finds the real <wishlist-button>. */
  function isMosaicWishlistCardContext(card) {
    if (!card || !card.closest) return false;
    return !!(
      card.closest('.collection-mosaic__item') ||
      card.closest('.cart-page-layout__reco-mosaic') ||
      card.closest('.vmx-wishlist-now')
    );
  }

  function findMosaicWishlistEngineFromEvent(ev) {
    var path = typeof ev.composedPath === 'function' ? ev.composedPath() : null;
    if (path && path.length) {
      for (var i = 0; i < path.length; i++) {
        var el = path[i];
        if (!el || el.nodeType !== 1 || !el.matches) continue;
        if (!el.matches('wishlist-button.wishlist-engine, .wishlist-engine')) continue;
        var card = el.closest && el.closest('.mosaic-card');
        if (!isMosaicWishlistCardContext(card)) continue;
        var host = el.matches('wishlist-button.wishlist-engine') ? el : el.closest && el.closest('wishlist-button.wishlist-engine');
        return host || el;
      }
    }
    var t = ev.target;
    if (t && t.nodeType === 1 && t.closest) {
      var eng = t.closest('wishlist-button.wishlist-engine') || t.closest('.wishlist-engine');
      if (!eng) return null;
      var card2 = eng.closest('.mosaic-card');
      if (!isMosaicWishlistCardContext(card2)) return null;
      return eng;
    }
    return null;
  }

  function onMosaicWishlistCaptureClick(ev) {
    var btn = findMosaicWishlistEngineFromEvent(ev);
    if (!btn) return;
    var card = btn.closest('.mosaic-card');
    if (!card) return;

    if (isSaved(btn)) {
      clearSavedCelebration(card);
      normalInfoDespiteWishlist.delete(card);
      markForcedUnsaved(card, 900);
    } else {
      normalInfoDespiteWishlist.delete(card);
      startSavedRowCelebrationCountdown(card);
    }
    // SE app updates attributes asynchronously.
    setTimeout(updateAllCards, 80);
    setTimeout(updateAllCards, 250);
    setTimeout(updateAllCards, 700);
    setTimeout(updateAllCards, 1000);
    setTimeout(updateAllCards, SAVED_ROW_CELEBRATION_MS + 200);
  }

  function initWishlistSavedRow() {
    updateAllCards();

    document.addEventListener('click', onMosaicWishlistCaptureClick, true);

    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') updateAllCards();
    });
    window.addEventListener('pageshow', updateAllCards);

    if (typeof MutationObserver !== 'undefined') {
      var obs = new MutationObserver(function (mutations) {
        var needsRefresh = false;
        mutations.forEach(function (mutation) {
          if (mutation.type === 'attributes' && mutation.target.matches && mutation.target.matches('.wishlist-engine')) {
            needsRefresh = true;
          }
          if (mutation.addedNodes && mutation.addedNodes.length) {
            mutation.addedNodes.forEach(function (n) {
              suppressWishlistPopupNode(n);
              if (n.querySelector && (n.querySelector('.wishlist-engine') || n.querySelector('.mosaic-card'))) {
                needsRefresh = true;
              }
            });
          }
        });
        if (needsRefresh) updateAllCards();
      });

      obs.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['data-total', 'data-added']
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWishlistSavedRow, { once: true });
  } else {
    initWishlistSavedRow();
  }
})();

// -----------------------------------------------------------------------------
// OVERLAY BACKSTACK: quick-add drawer + size chart close in order on back
// -----------------------------------------------------------------------------
(
  function () {
    'use strict';

    if (typeof window === 'undefined' || !window.history || !window.history.pushState) return;

    var managedEntries = 0;
    var closingFromPop = false;
    var syncingHistoryBack = false;

    function isQuickBuyOverlay(el) {
      return !!(el && el.matches && el.matches('quick-buy-modal'));
    }

    function isSizeChartOverlay(el) {
      return !!(el && el.matches && el.matches('size-chart-drawer'));
    }

    function pushOverlayEntry(type, id) {
      try {
        var nextState = Object.assign({}, window.history.state || {}, {
          __overlayManaged: true,
          __overlayType: type,
          __overlayId: id || '',
          __overlayTs: Date.now()
        });
        window.history.pushState(nextState, '', window.location.href);
        managedEntries += 1;
      } catch (e) {
        // no-op: history stack unavailable or restricted
      }
    }

    function topOpenSizeChart() {
      var nodes = document.querySelectorAll('size-chart-drawer[open]');
      return nodes.length ? nodes[nodes.length - 1] : null;
    }

    function topOpenQuickBuy() {
      var nodes = document.querySelectorAll('quick-buy-modal[open]');
      return nodes.length ? nodes[nodes.length - 1] : null;
    }

    function closeTopOverlayForBack() {
      var sizeChart = topOpenSizeChart();
      if (sizeChart && typeof sizeChart.hide === 'function') {
        closingFromPop = true;
        sizeChart.hide();
        return true;
      }

      var quickBuy = topOpenQuickBuy();
      if (quickBuy && typeof quickBuy.hide === 'function') {
        closingFromPop = true;
        quickBuy.hide();
        return true;
      }

      return false;
    }

    document.addEventListener(
      'dialog:after-show',
      function (event) {
        var target = event.target;
        if (!isQuickBuyOverlay(target) && !isSizeChartOverlay(target)) return;
        if (!target.hasAttribute('open')) return;

        pushOverlayEntry(isSizeChartOverlay(target) ? 'size-chart' : 'quick-buy', target.id);
      },
      true
    );

    document.addEventListener(
      'dialog:after-hide',
      function (event) {
        var target = event.target;
        if (!isQuickBuyOverlay(target) && !isSizeChartOverlay(target)) return;

        if (closingFromPop) {
          closingFromPop = false;
          return;
        }

        if (managedEntries > 0) {
          syncingHistoryBack = true;
          window.history.back();
        }
      },
      true
    );

    window.addEventListener('popstate', function () {
      if (syncingHistoryBack) {
        syncingHistoryBack = false;
        managedEntries = Math.max(0, managedEntries - 1);
        return;
      }

      if (managedEntries <= 0) return;

      var closed = closeTopOverlayForBack();
      if (closed) {
        managedEntries = Math.max(0, managedEntries - 1);
      }
    });
  }
)();

var WE_PRODUCT_CACHE_PREFIX = 'we_product_ctx_';
var WE_PRODUCT_CACHE_SHOPIFY_PREFIX = 'we_product_ctx_shopify_';

function weFindVariantRow(variants, lookupId) {
  variants = variants || [];
  lookupId = String(lookupId || '');
  var index;

  for (index = 0; index < variants.length; index += 1) {
    if (String(variants[index].shopify_variant_id) === lookupId) {
      return variants[index];
    }
    if (String(variants[index].variant_id) === lookupId) {
      return variants[index];
    }
  }

  return null;
}

function weGetProductCache(lookupId) {
  lookupId = String(lookupId || '');

  try {
    var raw = sessionStorage.getItem(WE_PRODUCT_CACHE_SHOPIFY_PREFIX + lookupId);

    if (raw) {
      return JSON.parse(raw);
    }

    raw = sessionStorage.getItem(WE_PRODUCT_CACHE_PREFIX + lookupId);
    return raw ? JSON.parse(raw) : {};
  } catch (error) {
    return {};
  }
}

function weCacheProductContext(payload) {
  payload = payload || {};

  try {
    var data = JSON.stringify(payload);

    if (payload.shopify_product_id) {
      sessionStorage.setItem(WE_PRODUCT_CACHE_SHOPIFY_PREFIX + String(payload.shopify_product_id), data);
    }

    if (payload.product_id) {
      sessionStorage.setItem(WE_PRODUCT_CACHE_PREFIX + String(payload.product_id), data);
    }
  } catch (error) {
    /* ignore */
  }
}

function weGetProductAnalyticsFromDom(shopifyProductId) {
  shopifyProductId = String(shopifyProductId || '');
  var selectors;
  var index;
  var node;
  var payload;

  if (!shopifyProductId) {
    return null;
  }

  selectors = [
    'script.webengage-product-analytics[data-product-id="' + shopifyProductId + '"]',
    'script.webengage-wishlist-analytics[data-product-id="' + shopifyProductId + '"]'
  ];

  for (index = 0; index < selectors.length; index += 1) {
    node = document.querySelector(selectors[index]);

    if (!node) {
      continue;
    }

    try {
      return JSON.parse(node.textContent || '{}');
    } catch (error) {
      /* try next node */
    }
  }

  node = document.getElementById('webengage-product-payload');

  if (node) {
    try {
      payload = JSON.parse(node.textContent || '{}');

      if (String(payload.shopify_product_id) === shopifyProductId) {
        return payload;
      }
    } catch (error) {
      return null;
    }
  }

  return null;
}

function weMergeProductContextFields(cached, domBase) {
  cached = cached || {};
  domBase = domBase || {};
  var merged = {};
  var key;
  var specFields = ['fit', 'sleeve', 'material', 'gender', 'default_color', 'color'];
  var categoryFields = [
    'l1_category_name',
    'l2_category_name',
    'l1_category_id',
    'l2_category_id',
    'product_name',
    'image_url',
    'sub_brand_name',
    'section',
    'view_type'
  ];

  for (key in domBase) {
    if (Object.prototype.hasOwnProperty.call(domBase, key)) {
      merged[key] = domBase[key];
    }
  }

  for (key in cached) {
    if (Object.prototype.hasOwnProperty.call(cached, key)) {
      merged[key] = cached[key];
    }
  }

  specFields.forEach(function (field) {
    if (!merged[field] && domBase[field]) {
      merged[field] = domBase[field];
    }

    if (!merged[field] && cached[field]) {
      merged[field] = cached[field];
    }
  });

  categoryFields.forEach(function (field) {
    if (!merged[field] && cached[field]) {
      merged[field] = cached[field];
    }

    if (!merged[field] && domBase[field]) {
      merged[field] = domBase[field];
    }
  });

  if (!merged.variants || !merged.variants.length) {
    merged.variants = cached.variants || domBase.variants || [];
  }

  return merged;
}

function weGetProductContext(shopifyProductId) {
  var cached = weGetProductCache(shopifyProductId);
  var domBase = weGetProductAnalyticsFromDom(shopifyProductId);

  if (!domBase) {
    return cached || {};
  }

  if (!cached || !cached.product_id) {
    return domBase;
  }

  return weMergeProductContextFields(cached, domBase);
}

function weSeedProductAnalyticsCacheFromDom(root) {
  root = root || document;
  var nodes = root.querySelectorAll(
    'script.webengage-product-analytics[data-product-id], script.webengage-wishlist-analytics[data-product-id]'
  );
  var payloadNode = root.getElementById ? root.getElementById('webengage-product-payload') : null;
  var index;

  for (index = 0; index < nodes.length; index += 1) {
    try {
      weCacheProductContext(JSON.parse(nodes[index].textContent || '{}'));
    } catch (error) {
      /* ignore invalid JSON */
    }
  }

  if (payloadNode) {
    try {
      weCacheProductContext(JSON.parse(payloadNode.textContent || '{}'));
    } catch (error) {
      /* ignore */
    }
  }
}

function weInitProductAnalyticsCacheSeeding() {
  weSeedProductAnalyticsCacheFromDom(document);

  if (!window.MutationObserver) {
    return;
  }

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (!node || node.nodeType !== 1) {
          return;
        }

        weSeedProductAnalyticsCacheFromDom(node);
      });
    });
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', weInitProductAnalyticsCacheSeeding);
} else {
  weInitProductAnalyticsCacheSeeding();
}

function weGetLastCategoryContextFromSession() {
  try {
    var raw = sessionStorage.getItem('we_last_category_ctx');
    return raw ? JSON.parse(raw) : null;
  } catch (error) {
    return null;
  }
}

function weEnrichAndCacheProductForCart(shopifyProductId, options) {
  shopifyProductId = String(shopifyProductId || '');
  options = options || {};

  if (!shopifyProductId) {
    return;
  }

  var domPayload = weGetProductAnalyticsFromDom(shopifyProductId);
  if (!domPayload) {
    return;
  }

  var enriched = weMergeProductContextFields({}, domPayload);
  var ctx = weGetLastCategoryContextFromSession();

  if (window.location.pathname.indexOf('/collections/') !== -1) {
    enriched.section = options.section || enriched.section || 'PLP';
  }

  if (options.view_type) {
    enriched.view_type = options.view_type;
  }

  if (ctx) {
    if (!enriched.l1_category_name) {
      enriched.l1_category_name = ctx.l1_category_name || '';
    }
    if (!enriched.l2_category_name) {
      enriched.l2_category_name = ctx.l2_category_name || '';
    }
    if (!enriched.l1_category_id) {
      enriched.l1_category_id = ctx.l1_category_id || '';
    }
    if (!enriched.l2_category_id) {
      enriched.l2_category_id = ctx.l2_category_id || '';
    }
  }

  weCacheProductContext(enriched);
}

document.addEventListener(
  'variant:add',
  function (event) {
    var detail = event.detail || {};
    var items = detail.items || [];
    var item = items[0] || {};
    var addContext = window.__weLastPlpAddContext || {};
    var viewType = addContext.view_type || '';

    weEnrichAndCacheProductForCart(String(item.product_id || ''), {
      section: addContext.section || 'PLP',
      view_type: viewType
    });

    window.__weLastPlpAddContext = null;
  },
  true
);

function weNormalizeImageUrl(url) {
  url = String(url || '').trim();

  if (!url) {
    return '';
  }

  if (url.indexOf('//') === 0) {
    return 'https:' + url;
  }

  return url;
}

function weResolveSubBrandName(gender) {
  gender = String(gender || '').trim().toLowerCase();

  if (gender === 'girls' || gender === 'girl') {
    return 'VERO MODA GIRLS';
  }

  return 'VERO MODA';
}

function weNormalizeProductPricing(mrp, totalPayable, discount) {
  mrp = Number(mrp) || 0;
  totalPayable = Number(totalPayable) || 0;
  discount = Number(discount);
  if (isNaN(discount) || (discount === 0 && mrp > totalPayable)) {
    discount = mrp > totalPayable ? mrp - totalPayable : 0;
  }

  return {
    mrp: mrp,
    total_payable: totalPayable,
    discount_on_mrp: discount
  };
}

function weGetUsableProductCategories(source) {
  source = source || {};
  var l1 = source.l1_category_name || '';
  var l2 = source.l2_category_name || '';

  if (String(l1).trim().toLowerCase() === 'all products') {
    l1 = '';
  }

  if (String(l2).trim().toLowerCase() === 'all products') {
    l2 = '';
  }

  return {
    l1_category_name: l1,
    l2_category_name: l2,
    l1_category_id: l1 ? String(source.l1_category_id || '') : '',
    l2_category_id: l2 ? String(source.l2_category_id || '') : ''
  };
}

var WE_MULTI_PRODUCT_STRING_FIELDS = [
  'product_id',
  'product_name',
  'variant_id',
  'sub_brand_name',
  'l1_category_name',
  'l2_category_name',
  'l1_category_id',
  'l2_category_id',
  'color',
  'fit',
  'sleeve',
  'material',
  'gender',
  'size',
  'image_url'
];

function weAggregateProductDetailField(details, field) {
  var values = [];

  (details || []).forEach(function (item) {
    if (item[field]) {
      values.push(String(item[field]));
    }
  });

  return values.filter(function (value, index) {
    return values.indexOf(value) === index;
  }).join(', ');
}

function weApplyAggregatedProductFields(target, details, fields) {
  target = target || {};
  fields = fields || WE_MULTI_PRODUCT_STRING_FIELDS;

  fields.forEach(function (field) {
    target[field] = weAggregateProductDetailField(details, field);
  });

  return target;
}

document.addEventListener('variant:change', function (event) {
  var variant = event.detail && event.detail.variant;
  if (!variant || !variant.id) return;

  document.querySelectorAll('wishlist-button').forEach(function (button) {
    button.dataset.variantId = String(variant.id);
  });
});

var WISHLIST_ANALYTICS_VIEW = 'webengage-analytics';
var WISHLIST_ENRICH_TIMEOUT_MS = 3500;
var weProductAnalyticsFetchPromises = Object.create(null);

function weShopifyRoot() {
  return typeof Shopify !== 'undefined' && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
}

function weParseProductAnalyticsFromHtml(html, shopifyProductId) {
  shopifyProductId = String(shopifyProductId || '');
  var doc = new DOMParser().parseFromString(html, 'text/html');
  var nodes = doc.querySelectorAll(
    'script.webengage-product-analytics[data-product-id="' +
      shopifyProductId +
      '"], script.webengage-wishlist-analytics[data-product-id="' +
      shopifyProductId +
      '"], #webengage-product-payload'
  );
  var index;
  var node;
  var payload;

  for (index = 0; index < nodes.length; index += 1) {
    node = nodes[index];

    try {
      payload = JSON.parse(node.textContent || '{}');

      if (!shopifyProductId || String(payload.shopify_product_id) === shopifyProductId) {
        return payload;
      }
    } catch (error) {
      /* try next node */
    }
  }

  return null;
}

function weFetchProductAnalyticsPayload(handle, shopifyProductId) {
  handle = String(handle || '').trim();
  shopifyProductId = String(shopifyProductId || '');

  if (!handle) {
    return Promise.resolve(null);
  }

  return fetch(
    weShopifyRoot() +
      'products/' +
      encodeURIComponent(handle) +
      '?view=' +
      encodeURIComponent(WISHLIST_ANALYTICS_VIEW)
  )
    .then(function (response) {
      if (!response.ok) {
        return null;
      }

      var contentType = String(response.headers.get('content-type') || '').toLowerCase();

      if (contentType.indexOf('json') !== -1) {
        return response.json();
      }

      return response.text().then(function (html) {
        var lookupId = shopifyProductId;

        if (!lookupId && html) {
          try {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var node = doc.querySelector(
              'script.webengage-product-analytics[data-product-id], script.webengage-wishlist-analytics[data-product-id]'
            );
            lookupId = node ? String(node.getAttribute('data-product-id') || '') : '';
          } catch (error) {
            lookupId = '';
          }
        }

        return html ? weParseProductAnalyticsFromHtml(html, lookupId) : null;
      });
    })
    .catch(function () {
      return null;
    });
}

function weApplyProductAnalyticsOptions(payload, options) {
  options = options || {};

  if (!payload) {
    return payload;
  }

  if (options.section) {
    payload.section = options.section;
  }

  if (options.view_type) {
    payload.view_type = options.view_type;
  }

  weCacheProductContext(payload);
  return payload;
}

function weFetchAndCacheProductAnalytics(handle, shopifyProductId, options) {
  handle = String(handle || '').trim();
  shopifyProductId = String(shopifyProductId || '');
  options = options || {};

  if (!handle || !shopifyProductId) {
    return Promise.resolve(null);
  }

  if (weProductAnalyticsFetchPromises[shopifyProductId]) {
    return weProductAnalyticsFetchPromises[shopifyProductId];
  }

  weProductAnalyticsFetchPromises[shopifyProductId] = weFetchProductAnalyticsPayload(handle, shopifyProductId)
    .then(function (payload) {
      return weApplyProductAnalyticsOptions(payload, options);
    })
    .finally(function () {
      delete weProductAnalyticsFetchPromises[shopifyProductId];
    });

  return weProductAnalyticsFetchPromises[shopifyProductId];
}

function weFetchProductAnalyticsByHandle(handle, options) {
  handle = String(handle || '').trim();
  options = options || {};
  var promiseKey = 'handle:' + handle;

  if (!handle) {
    return Promise.resolve(null);
  }

  if (weProductAnalyticsFetchPromises[promiseKey]) {
    return weProductAnalyticsFetchPromises[promiseKey];
  }

  weProductAnalyticsFetchPromises[promiseKey] = weFetchProductAnalyticsPayload(handle, '')
    .then(function (payload) {
      return weApplyProductAnalyticsOptions(payload, options);
    })
    .finally(function () {
      delete weProductAnalyticsFetchPromises[promiseKey];
    });

  return weProductAnalyticsFetchPromises[promiseKey];
}

(function () {
  var WISHLIST_API_BASE = 'https://livewishlist.scriptengine.net/api';
  var WISHLIST_STORE_ID_KEY = 'we_wishlist_store_id';
  var lastWishlistViewedAt = 0;
  var lastWishlistActionKey = '';
  var lastWishlistActionAt = 0;
  var weWishlistColumnSeedKeys = Object.create(null);

  function getHandleFromWishlistItem(item) {
    item = item || {};

    if (item.handle) {
      return String(item.handle);
    }

    if (item.product_handle) {
      return String(item.product_handle);
    }

    var productUrl = String(item.url || item.product_url || item.link || '');

    if (productUrl) {
      try {
        var parsed = new URL(productUrl, window.location.origin);
        var match = parsed.pathname.match(/\/products\/([^/?#]+)/);
        if (match) {
          return decodeURIComponent(match[1]);
        }
      } catch (error) {
        /* ignore */
      }
    }

    return parseHandleFromWishlistColumn(
      findWishlistColumnByProductId(item.shopify_id || item.product_id || item.id)
    );
  }

  function wishlistItemNeedsEnrichment(shopifyProductId) {
    var cached = weGetProductContext(String(shopifyProductId || ''));
    return !String(cached.product_id || '').trim();
  }

  function resolveWishlistItemShopifyVariantId(item, cached) {
    item = item || {};
    cached = cached || {};
    var shopifyVariantId = String(item.shopify_variant_id || item.variant_id || '');

    if (shopifyVariantId) {
      return shopifyVariantId;
    }

    if (cached.variants && cached.variants.length === 1) {
      return String(cached.variants[0].shopify_variant_id || '');
    }

    return shopifyVariantId;
  }

  function wishlistItemNeedsAnalyticsEnrichment(item) {
    item = item || {};
    var shopifyProductId = String(item.shopify_id || item.product_id || item.id || '');
    var handle = getHandleFromWishlistItem(item);

    if (!shopifyProductId && handle) {
      return true;
    }

    if (!shopifyProductId) {
      return false;
    }

    var cached = weGetProductContext(shopifyProductId);

    if (!String(cached.product_id || '').trim()) {
      return true;
    }

    var shopifyVariantId = resolveWishlistItemShopifyVariantId(item, cached);
    var variantRow = shopifyVariantId ? weFindVariantRow(cached.variants, shopifyVariantId) : null;

    return !(variantRow && String(variantRow.variant_id || '').trim());
  }

  function isCompleteWishlistDetail(mapped) {
    mapped = mapped || {};
    return !!(String(mapped.product_id || '').trim() && String(mapped.variant_id || '').trim());
  }

  function wishlistDetailIsTrackable(mapped, sourceItem) {
    mapped = mapped || {};
    sourceItem = sourceItem || {};

    if (String(mapped.product_id || '').trim()) {
      return true;
    }

    if (String(mapped.shopify_product_id || '').trim()) {
      return true;
    }

    if (String(mapped.product_name || '').trim()) {
      return true;
    }

    if (String(sourceItem.handle || sourceItem.product_handle || '').trim()) {
      return true;
    }

    return !!(String(sourceItem.shopify_id || sourceItem.product_id || sourceItem.id || '').trim());
  }

  function withWishlistEnrichTimeout(promise, timeoutMs) {
    timeoutMs = Number(timeoutMs) || WISHLIST_ENRICH_TIMEOUT_MS;

    return Promise.race([
      promise,
      new Promise(function (resolve) {
        setTimeout(function () {
          resolve(null);
        }, timeoutMs);
      })
    ]);
  }

  function enrichWishlistItems(items, timeoutMs) {
    items = items || [];
    var tasks = [];
    var index;
    var enrichOptions = {
      section: 'Wishlist',
      view_type: 'normal'
    };

    for (index = 0; index < items.length; index += 1) {
      (function (item) {
        var shopifyProductId = String(item.shopify_id || item.product_id || item.id || '');
        var handle = getHandleFromWishlistItem(item);

        if (!wishlistItemNeedsAnalyticsEnrichment(item)) {
          return;
        }

        if (!handle && !shopifyProductId) {
          return;
        }

        if (!shopifyProductId && handle) {
          tasks.push(
            withWishlistEnrichTimeout(
              weFetchProductAnalyticsByHandle(handle, enrichOptions).then(function (payload) {
                if (payload && payload.shopify_product_id) {
                  item.shopify_id = String(payload.shopify_product_id);
                  item.product_id = item.shopify_id;
                }

                return payload;
              }),
              timeoutMs
            )
          );
          return;
        }

        if (!handle) {
          return;
        }

        tasks.push(
          withWishlistEnrichTimeout(
            weFetchAndCacheProductAnalytics(handle, shopifyProductId, enrichOptions).then(function (payload) {
              if (payload && payload.shopify_product_id && !item.shopify_id) {
                item.shopify_id = String(payload.shopify_product_id);
                item.product_id = item.shopify_id;
              }

              return payload;
            }),
            timeoutMs
          )
        );
      })(items[index]);
    }

    if (!tasks.length) {
      return Promise.resolve();
    }

    return Promise.all(tasks).then(function () {});
  }

  function getWishlistCookie(name) {
    var prefix = name + '=';
    var parts = document.cookie.split(';');

    for (var i = 0; i < parts.length; i += 1) {
      var part = parts[i].trim();
      if (part.indexOf(prefix) === 0) {
        try {
          return decodeURIComponent(part.substring(prefix.length));
        } catch (error) {
          return part.substring(prefix.length);
        }
      }
    }

    return '';
  }

  function getWishlistCustomerRecords() {
    var node = document.getElementById('wishlist-engine-customer-records');

    try {
      return JSON.parse((node && node.textContent) || '{}');
    } catch (error) {
      return {};
    }
  }

  function publishAnalyticsEvent(eventName, payload) {
    if (typeof Shopify === 'undefined' || !Shopify.analytics || !Shopify.analytics.publish) {
      return;
    }

    Shopify.analytics.publish(eventName, payload);
  }

  function countWishlistColumnsInDom() {
    return document.querySelectorAll('.wishlist-page .wh-list-column, .wishlist-page .wh-grid-column').length;
  }

  function readWishlistHeaderTotal() {
    var node = document.querySelector('.wishlist-total-count');

    if (!node) {
      return 0;
    }

    var total = parseInt(node.getAttribute('data-total') || node.textContent, 10);
    return !isNaN(total) && total > 0 ? total : 0;
  }

  function getWishlistTotalFromDom() {
    var headerTotal = readWishlistHeaderTotal();
    var columnTotal = isWishlistPage() ? countWishlistColumnsInDom() : 0;
    var cookieTotal = parseInt(getWishlistCookie('WISHLIST_TOTAL'), 10);
    cookieTotal = !isNaN(cookieTotal) && cookieTotal > 0 ? cookieTotal : 0;

    return Math.max(headerTotal, columnTotal, cookieTotal);
  }

  function resolveWishlistTotal(items, productDetails, meta) {
    var candidates = [
      Number(meta && meta.total_items_in_wishlist) || 0,
      (items && items.length) || 0,
      getWishlistTotalFromDom(),
      isWishlistPage() ? countWishlistColumnsInDom() : 0,
      (productDetails && productDetails.length) || 0
    ];
    var max = 0;
    var index;

    for (index = 0; index < candidates.length; index += 1) {
      if (candidates[index] > max) {
        max = candidates[index];
      }
    }

    return max;
  }

  function normalizeWishlistApiItems(data) {
    if (Array.isArray(data)) {
      return data;
    }

    if (!data || typeof data !== 'object') {
      return [];
    }

    if (Array.isArray(data.products)) {
      return data.products;
    }

    if (Array.isArray(data.items)) {
      return data.items;
    }

    return Object.keys(data)
      .map(function (key) {
        return data[key];
      })
      .filter(function (item) {
        return item && typeof item === 'object';
      });
  }

  function parseVariantIdFromWishlistColumn(column) {
    if (!column) {
      return '';
    }

    var button = column.querySelector(
      '.wishlist-move-cart, button.wishlist-cart, .wh-wishlist-remove, wishlist-button'
    );
    var raw;

    if (button) {
      raw =
        button.getAttribute('data-variant_id') ||
        button.getAttribute('data-variant-id') ||
        button.getAttribute('data-old-variant_id') ||
        (button.dataset && (button.dataset.variantId || button.dataset.variant_id));

      if (raw) {
        return String(raw);
      }
    }

    var select = column.querySelector('select[name="id"], select[name="variant"], select[name="variant_id"]');

    if (select && select.value) {
      return String(select.value);
    }

    var input = column.querySelector('input[name="id"][value]');

    if (input && input.value) {
      return String(input.value);
    }

    return '';
  }

  function mapWishlistItemFromDomColumn(column) {
    var shopifyProductId = parseProductIdFromWishlistColumn(column);
    var handle = parseHandleFromWishlistColumn(column);
    var shopifyVariantId = parseVariantIdFromWishlistColumn(column);

    if (!shopifyProductId && !handle) {
      return null;
    }

    return {
      shopify_id: shopifyProductId,
      product_id: shopifyProductId,
      shopify_variant_id: shopifyVariantId,
      handle: handle
    };
  }

  function getWishlistItemsFromDom() {
    if (!isWishlistPage()) {
      return [];
    }

    var columns = document.querySelectorAll('.wishlist-page .wh-list-column, .wishlist-page .wh-grid-column');
    var items = [];
    var index;
    var mapped;

    for (index = 0; index < columns.length; index += 1) {
      mapped = mapWishlistItemFromDomColumn(columns[index]);

      if (mapped) {
        items.push(mapped);
      }
    }

    return items;
  }

  function mergeWishlistItemLists(primary, supplemental) {
    primary = primary || [];
    supplemental = supplemental || [];
    var seen = Object.create(null);
    var merged = [];
    var index;
    var item;
    var key;

    function addItem(listItem) {
      if (!listItem) {
        return;
      }

      if (listItem.handle && !listItem.shopify_id && !listItem.product_id && !listItem.id) {
        key = 'handle:' + String(listItem.handle);
      } else {
        key =
          String(listItem.shopify_id || listItem.product_id || listItem.id || '') +
          ':' +
          String(listItem.shopify_variant_id || listItem.variant_id || '');
      }

      if (!key || key === ':') {
        return;
      }

      if (seen[key]) {
        return;
      }

      seen[key] = true;
      merged.push(listItem);
    }

    for (index = 0; index < primary.length; index += 1) {
      addItem(primary[index]);
    }

    for (index = 0; index < supplemental.length; index += 1) {
      addItem(supplemental[index]);
    }

    return merged;
  }

  function resolveWishlistItemsForSummary(apiItems) {
    apiItems = apiItems || [];
    var domItems = getWishlistItemsFromDom();

    if (domItems.length > apiItems.length) {
      return mergeWishlistItemLists(domItems, apiItems);
    }

    return mergeWishlistItemLists(apiItems, domItems);
  }

  function whenWishlistDomStable(callback) {
    callback = typeof callback === 'function' ? callback : function () {};
    var lastCount = -1;
    var stablePasses = 0;
    var attempts = 0;
    var maxAttempts = 16;

    function tick() {
      attempts += 1;
      var columnCount = countWishlistColumnsInDom();
      var headerTotal = readWishlistHeaderTotal();
      var isEmpty = !!document.querySelector('.wishlistnoitem, .wishlsitnoitem, .wishlist-no-item');

      if (columnCount === lastCount && columnCount > 0) {
        stablePasses += 1;
      } else {
        stablePasses = 0;
        lastCount = columnCount;
      }

      var expected = Math.max(headerTotal, columnCount);
      var columnsReady = columnCount > 0 && stablePasses >= 2;
      var headerSynced = headerTotal <= 0 || columnCount >= headerTotal || stablePasses >= 3;

      if (isEmpty || attempts >= maxAttempts || (columnsReady && headerSynced) || (expected > 0 && columnCount >= expected)) {
        callback();
        return;
      }

      setTimeout(tick, 400);
    }

    tick();
  }

  function buildWishlistRequestBody(extra) {
    var records = getWishlistCustomerRecords();
    var body = {
      uuid: getWishlistCookie('WISHLIST_UUID') || '',
      ip_address: getWishlistCookie('WISHLIST_IP_ADDRESS') || '',
      customer_id: records.id || '',
      customers: records,
      shopify_store_id: sessionStorage.getItem(WISHLIST_STORE_ID_KEY) || '',
      shopify_store: typeof Shopify !== 'undefined' ? Shopify.shop : '',
      search: '',
      active_currency: (typeof Shopify !== 'undefined' && Shopify.currency && Shopify.currency.active) || '',
      share_id: '',
      shopify_local_language: (typeof Shopify !== 'undefined' && Shopify.locale) || 'en'
    };

    if (extra) {
      Object.keys(extra).forEach(function (key) {
        body[key] = extra[key];
      });
    }

    return body;
  }

  function wishlistApiPost(path, body) {
    return fetch(WISHLIST_API_BASE + path, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(body)
    }).then(function (response) {
      return response.json();
    });
  }

  function ensureWishlistStoreId(callback) {
    var cached = sessionStorage.getItem(WISHLIST_STORE_ID_KEY);

    if (cached) {
      callback(cached);
      return;
    }

    wishlistApiPost('/apps-config', buildWishlistRequestBody({ shop: typeof Shopify !== 'undefined' ? Shopify.shop : '' }))
      .then(function (response) {
        var storeId = response && response.data && response.data.id ? String(response.data.id) : '';

        if (storeId) {
          sessionStorage.setItem(WISHLIST_STORE_ID_KEY, storeId);
        }

        callback(storeId);
      })
      .catch(function () {
        callback('');
      });
  }

  function mapWishlistApiItem(item) {
    item = item || {};
    var shopifyProductId = String(item.shopify_id || item.product_id || '');
    var shopifyVariantId = String(item.shopify_variant_id || item.variant_id || '');
    var cached = weGetProductContext(shopifyProductId);

    if (!shopifyProductId && cached.shopify_product_id) {
      shopifyProductId = String(cached.shopify_product_id);
    }

    shopifyVariantId = resolveWishlistItemShopifyVariantId(item, cached);
    var variantRow = weFindVariantRow(cached.variants, shopifyVariantId);
    var categories = weGetUsableProductCategories(cached);
    var variants = item.variants || {};
    var variant = variants[shopifyVariantId] || variants[item.shopify_variant_id] || {};
    var price = Number(variant.price || item.price || 0);
    var compareAt = Number(variant.compare_at_price || variant.compare_at || price);
    var lineDiscount = compareAt > price ? compareAt - price : 0;
    var mrp = Number((variantRow && variantRow.mrp) || cached.mrp) || compareAt;
    var totalPayable = Number((variantRow && variantRow.total_payable) || cached.total_payable) || price;
    var discountSource = variantRow && variantRow.discount_on_mrp != null && variantRow.discount_on_mrp !== ''
      ? variantRow.discount_on_mrp
      : cached.discount_on_mrp;
    var discountVal = discountSource != null && discountSource !== ''
      ? Number(discountSource)
      : lineDiscount;
    var pricing = weNormalizeProductPricing(mrp, totalPayable, discountVal);
    var quantity = Number(item.quntity || item.quantity || 1);

    if (isNaN(quantity) || quantity <= 0) {
      quantity = 1;
    }

    var erpProductId = String(cached.product_id || '').trim();
    var erpVariantId = String((variantRow && variantRow.variant_id) || item.sku || '').trim();

    if (!erpProductId && shopifyProductId) {
      erpProductId = shopifyProductId;
    }

    if (!erpVariantId && shopifyVariantId) {
      erpVariantId = shopifyVariantId;
    }

    return {
      product_id: erpProductId,
      product_name: cached.product_name || item.title || item.product_name || item.name || '',
      variant_id: erpVariantId,
      shopify_product_id: shopifyProductId,
      shopify_variant_id: shopifyVariantId,
      image_url: variant.image_src || item.image || cached.image_url || '',
      sub_brand_name: weResolveSubBrandName(cached.gender),
      l1_category_name: categories.l1_category_name,
      l2_category_name: categories.l2_category_name,
      l1_category_id: categories.l1_category_id,
      l2_category_id: categories.l2_category_id,
      mrp: pricing.mrp,
      discount_on_mrp: pricing.discount_on_mrp,
      total_payable: pricing.total_payable,
      in_stock: variantRow ? !!variantRow.in_stock : (cached.in_stock !== undefined ? !!cached.in_stock : true),
      color: (variantRow && variantRow.color) || cached.color || '',
      fit: cached.fit || '',
      sleeve: cached.sleeve || '',
      material: cached.material || '',
      gender: cached.gender || '',
      size: (variantRow && variantRow.size) || cached.size || '',
      section: cached.section || '',
      view_type: cached.view_type || 'normal',
      quantity: quantity
    };
  }

  function parseHandleFromWishlistColumn(column) {
    if (!column) {
      return '';
    }

    var link = column.querySelector(
      '.wh-pro-meta h3 a[href*="/products/"], h3 a[href*="/products/"], a[href*="/products/"]'
    );

    if (!link || !link.getAttribute('href')) {
      return '';
    }

    try {
      var url = new URL(link.href, window.location.origin);
      var match = url.pathname.match(/\/products\/([^/?#]+)/);
      return match ? decodeURIComponent(match[1]) : '';
    } catch (error) {
      return '';
    }
  }

  function parseProductIdFromWishlistColumn(column) {
    if (!column) {
      return '';
    }

    var node = column.querySelector(
      '[data-product-id], [data-product_id], wishlist-button[data-product-id], wishlist-button[data-product_id]'
    );

    if (node) {
      return String(node.getAttribute('data-product-id') || node.getAttribute('data-product_id') || '');
    }

    var columnId = column.getAttribute('data-product-id') || column.getAttribute('data-product_id');

    return columnId ? String(columnId) : '';
  }

  function findWishlistColumnByProductId(shopifyProductId) {
    shopifyProductId = String(shopifyProductId || '');

    if (!shopifyProductId) {
      return null;
    }

    var node = document.querySelector(
      '.wh-list-column [data-product-id="' +
        shopifyProductId +
        '"], .wh-grid-column [data-product-id="' +
        shopifyProductId +
        '"], .wh-list-column [data-product_id="' +
        shopifyProductId +
        '"], .wh-grid-column [data-product_id="' +
        shopifyProductId +
        '"]'
    );

    return node ? node.closest('.wh-list-column, .wh-grid-column') : null;
  }

  function getWishlistProductHandle(product) {
    product = product || {};

    if (product.handle) {
      return String(product.handle);
    }

    var column = findWishlistColumnByProductId(product.shopify_id || product.product_id || product.id);
    return parseHandleFromWishlistColumn(column);
  }

  function seedWishlistColumnProductCache(column) {
    var handle = parseHandleFromWishlistColumn(column);
    var shopifyProductId = parseProductIdFromWishlistColumn(column);
    var seedKey = shopifyProductId || handle;

    if (!handle || weWishlistColumnSeedKeys[seedKey]) {
      return;
    }

    weWishlistColumnSeedKeys[seedKey] = true;

    if (shopifyProductId) {
      weFetchAndCacheProductAnalytics(handle, shopifyProductId, {
        section: 'Wishlist',
        view_type: 'normal'
      });
      return;
    }

    weFetchProductAnalyticsByHandle(handle, {
      section: 'Wishlist',
      view_type: 'normal'
    });
  }

  function seedWishlistPageProductCaches(root) {
    root = root || document;
    root.querySelectorAll('.wh-list-column, .wh-grid-column').forEach(seedWishlistColumnProductCache);
  }

  function mapWishlistActionPayload(product) {
    if (!product) {
      return null;
    }

    var shopifyProductId = String(product.shopify_id || product.product_id || product.id || '');
    var shopifyVariantId = String(product.shopify_variant_id || product.variant_id || product.variant || '');
    var cached = weGetProductContext(shopifyProductId);
    var payload = mapWishlistApiItem({
      shopify_id: shopifyProductId,
      shopify_variant_id: shopifyVariantId,
      title: product.title || product.product_name || product.name,
      product_name: product.product_name || product.name,
      sku: product.sku,
      price: product.price,
      compare_at_price: product.compare_at_price || product.compare_at,
      vendor: product.vendor,
      image: product.image || product.image_src,
      quantity: product.quntity || product.quantity || 1,
      variants: product.variants || {}
    });

    payload.shopify_product_id = shopifyProductId;
    payload.shopify_variant_id = shopifyVariantId;
    payload.variants = (cached && cached.variants) || [];

    if (isWishlistPage()) {
      payload.section = payload.section || 'Wishlist';
    }

    return payload;
  }

  function enrichWishlistActionPayload(product, actionPayload, callback) {
    callback = typeof callback === 'function' ? callback : function () {};

    if (!product || !actionPayload) {
      callback(actionPayload);
      return;
    }

    var shopifyProductId = String(product.shopify_id || product.product_id || product.id || '');

    if (isCompleteWishlistDetail(actionPayload) && !wishlistItemNeedsEnrichment(shopifyProductId)) {
      callback(actionPayload);
      return;
    }

    var handle = getWishlistProductHandle(product);

    if (!handle || !shopifyProductId) {
      callback(actionPayload);
      return;
    }

    weFetchAndCacheProductAnalytics(handle, shopifyProductId, {
      section: isWishlistPage() ? 'Wishlist' : actionPayload.section || '',
      view_type: actionPayload.view_type || 'normal'
    }).then(function () {
      callback(mapWishlistActionPayload(product) || actionPayload);
    });
  }

  function mapWishlistCallbackProduct(product) {
    var payload = mapWishlistActionPayload(product);

    if (!payload) {
      return null;
    }

    return {
      product_id: payload.product_id,
      product_name: payload.product_name,
      variant_id: payload.variant_id
    };
  }

  function buildWishlistSummary(items, meta) {
    var productDetails = [];
    var subtotal = 0;
    var index;
    var mapped;

    items = items || [];
    meta = meta || {};

    for (index = 0; index < items.length; index += 1) {
      mapped = mapWishlistApiItem(items[index]);

      if (!wishlistDetailIsTrackable(mapped, items[index])) {
        continue;
      }

      productDetails.push(mapped);

      if (Number(mapped.total_payable) > 0) {
        subtotal += mapped.total_payable * (mapped.quantity || 1);
      }
    }

    subtotal = Math.round(subtotal * 100) / 100;

    var summary = {
      total_items_in_wishlist: resolveWishlistTotal(items, productDetails, meta),
      subtotal: subtotal,
      total_payable: subtotal,
      product_details: productDetails
    };

    weApplyAggregatedProductFields(summary, productDetails);

    if (meta.action) {
      summary.action = meta.action;
    }

    return summary;
  }

  function enrichWishlistItemsSequential(items) {
    items = items || [];
    var index = 0;
    var enrichOptions = {
      section: 'Wishlist',
      view_type: 'normal'
    };

    function step() {
      if (index >= items.length) {
        return Promise.resolve();
      }

      var item = items[index];
      index += 1;
      var shopifyProductId = String(item.shopify_id || item.product_id || item.id || '');
      var handle = getHandleFromWishlistItem(item);
      var fetchPromise = null;

      if (handle && shopifyProductId) {
        fetchPromise = weFetchAndCacheProductAnalytics(handle, shopifyProductId, enrichOptions);
      } else if (handle) {
        fetchPromise = weFetchProductAnalyticsByHandle(handle, enrichOptions);
      } else if (shopifyProductId && wishlistItemNeedsAnalyticsEnrichment(item)) {
        handle = getWishlistProductHandle(item);

        if (handle) {
          fetchPromise = weFetchAndCacheProductAnalytics(handle, shopifyProductId, enrichOptions);
        }
      }

      if (!fetchPromise) {
        return step();
      }

      return fetchPromise
        .then(function (payload) {
          if (payload && payload.shopify_product_id) {
            item.shopify_id = String(payload.shopify_product_id);
            item.product_id = item.shopify_id;
          }
        })
        .catch(function () {})
        .then(step);
    }

    return step();
  }

  function publishEnrichedWishlistSummary(eventName, items, meta) {
    items = items || [];

    enrichWishlistItemsSequential(items).then(function () {
      publishAnalyticsEvent(eventName, buildWishlistSummary(items, meta));
    });
  }

  function fetchWishlistItems(callback) {
    ensureWishlistStoreId(function (storeId) {
      var body = buildWishlistRequestBody();
      body.shopify_store_id = storeId;

      wishlistApiPost('/apps-wishlist', body)
        .then(function (response) {
          callback(normalizeWishlistApiItems(response && response.data));
        })
        .catch(function () {
          wishlistApiPost('/get-all-product', body)
            .then(function (fallbackResponse) {
              callback(normalizeWishlistApiItems(fallbackResponse && fallbackResponse.data));
            })
            .catch(function () {
              callback([]);
            });
        });
    });
  }

  function publishWishlistUpdated(action, changedProduct) {
    fetchWishlistItems(function (apiItems) {
      var items = resolveWishlistItemsForSummary(apiItems);
      var meta = {
        action: action,
        total_items_in_wishlist: Math.max(getWishlistTotalFromDom(), items.length)
      };

      if (changedProduct) {
        meta.product_id = changedProduct.product_id;
        meta.product_name = changedProduct.product_name;
        meta.variant_id = changedProduct.variant_id;
      }

      publishEnrichedWishlistSummary('bestseller:wishlist_updated', items, meta);
    });
  }

  function publishWishlistViewed() {
    var now = Date.now();

    if (now - lastWishlistViewedAt < 2000) {
      return;
    }

    whenWishlistDomStable(function () {
      fetchWishlistItems(function (apiItems) {
        var items = resolveWishlistItemsForSummary(apiItems);
        lastWishlistViewedAt = Date.now();
        publishEnrichedWishlistSummary('bestseller:wishlist_viewed', items, {
          total_items_in_wishlist: Math.max(getWishlistTotalFromDom(), items.length)
        });
      });
    });
  }

  function isWishlistPage() {
    var path = window.location.pathname;
    return path === '/pages/wishlist' || path.indexOf('/apps/wishlist') === 0;
  }

  function initWishlistPageViewTracking() {
    if (!isWishlistPage()) {
      return;
    }

    var publishTimer = null;
    var WISHLIST_VIEW_DEBOUNCE_MS = 1200;

    function schedulePublish() {
      if (publishTimer) {
        clearTimeout(publishTimer);
      }

      publishTimer = setTimeout(function () {
        publishTimer = null;
        publishWishlistViewed();
      }, WISHLIST_VIEW_DEBOUNCE_MS);
    }

    var observer = new MutationObserver(function () {
      var container = document.querySelector('.wishlistajaxLoad, .wishlist-row');

      if (
        container &&
        container.querySelector('[id^="wishlist_page_"], .wh-list-column, .wh-grid-column, .wishlsitnoitem')
      ) {
        seedWishlistPageProductCaches(container);
        schedulePublish();
      }
    });

    var page = document.querySelector('.wishlist-page');

    if (page) {
      observer.observe(page, { childList: true, subtree: true });
    }

    setTimeout(function () {
      seedWishlistPageProductCaches(document);
      schedulePublish();
    }, 2500);
  }

  function shouldPublishWishlistAction(action, payload) {
    if (!payload) {
      return false;
    }

    var key =
      action +
      ':' +
      String(payload.shopify_product_id || payload.product_id || '') +
      ':' +
      String(payload.shopify_variant_id || payload.variant_id || '');
    var now = Date.now();

    if (key && key === lastWishlistActionKey && now - lastWishlistActionAt < 3000) {
      return false;
    }

    lastWishlistActionKey = key;
    lastWishlistActionAt = now;
    return true;
  }

  function publishWishlistActionEvent(action, product, actionPayload) {
    if (!actionPayload) {
      return;
    }

    if (action === 'add' && shouldPublishWishlistAction('add', actionPayload)) {
      publishAnalyticsEvent('add_to_wishlist', actionPayload);
      return;
    }

    if (action === 'remove' && shouldPublishWishlistAction('remove', actionPayload)) {
      publishAnalyticsEvent('remove_from_wishlist', actionPayload);
    }
  }

  window.wishlistCallback = function (data) {
    data = data || {};
    var actionMap = {
      ADD: 'add',
      REMOVE: 'remove',
      MOVETOCART: 'move_to_cart'
    };
    var action = actionMap[data.event] || String(data.event || '').toLowerCase();
    var actionPayload = mapWishlistActionPayload(data.product);

    if (action === 'add' || action === 'remove') {
      enrichWishlistActionPayload(data.product, actionPayload, function (finalPayload) {
        publishWishlistActionEvent(action, data.product, finalPayload);
      });
    }

    setTimeout(function () {
      publishWishlistUpdated(action, mapWishlistCallbackProduct(data.product));
    }, 300);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWishlistPageViewTracking);
  } else {
    initWishlistPageViewTracking();
  }
})();

(function () {
  var PRODUCT_CACHE_PREFIX = 'we_product_ctx_';
  var PRODUCT_CACHE_SHOPIFY_PREFIX = 'we_product_ctx_shopify_';

  function findVariantRow(variants, lookupId) {
    variants = variants || [];
    lookupId = String(lookupId || '');
    var index;

    for (index = 0; index < variants.length; index += 1) {
      if (String(variants[index].shopify_variant_id) === lookupId) {
        return variants[index];
      }
      if (String(variants[index].variant_id) === lookupId) {
        return variants[index];
      }
    }

    return null;
  }

  function getThemeProductCache(productId) {
    productId = String(productId || '');

    try {
      var raw = sessionStorage.getItem(PRODUCT_CACHE_SHOPIFY_PREFIX + productId);

      if (raw) {
        return JSON.parse(raw);
      }

      raw = sessionStorage.getItem(PRODUCT_CACHE_PREFIX + productId);
      return raw ? JSON.parse(raw) : {};
    } catch (error) {
      return {};
    }
  }

  function centsToAmount(cents) {
    return Number(cents || 0) / 100;
  }

  function normalizeProductPricing(mrp, totalPayable, discount) {
    mrp = Number(mrp) || 0;
    totalPayable = Number(totalPayable) || 0;
    discount = Number(discount);
    if (isNaN(discount) || (discount === 0 && mrp > totalPayable)) {
      discount = mrp > totalPayable ? mrp - totalPayable : 0;
    }

    return {
      mrp: mrp,
      total_payable: totalPayable,
      discount_on_mrp: discount
    };
  }

  function mapCartLineForCheckout(item) {
    item = item || {};
    var shopifyProductId = String(item.product_id || '');
    var shopifyVariantId = String(item.variant_id || '');
    var cached = weGetProductContext(shopifyProductId);
    var variantRow = findVariantRow(cached.variants, shopifyVariantId);
    var price = centsToAmount(item.final_price || item.price);
    var compareAt = centsToAmount(item.original_price || item.price);
    var lineDiscount = compareAt > price ? compareAt - price : 0;
    var mrp = Number((variantRow && variantRow.mrp) || cached.mrp) || compareAt;
    var totalPayable = Number((variantRow && variantRow.total_payable) || cached.total_payable) || price;
    var discountSource = variantRow && variantRow.discount_on_mrp != null && variantRow.discount_on_mrp !== ''
      ? variantRow.discount_on_mrp
      : cached.discount_on_mrp;
    var discountVal = discountSource != null && discountSource !== ''
      ? Number(discountSource)
      : lineDiscount;
    var pricing = normalizeProductPricing(mrp, totalPayable, discountVal);
    var color = (variantRow && variantRow.color) || cached.color || cached.default_color || '';

    return {
      product_id: String(cached.product_id || ''),
      shopify_product_id: shopifyProductId,
      shopify_variant_id: shopifyVariantId,
      product_name: item.product_title || cached.product_name || '',
      variant_id: String((variantRow && variantRow.variant_id) || item.sku || ''),
      image_url: item.image || item.featured_image || cached.image_url || '',
      sub_brand_name: weResolveSubBrandName(cached.gender),
      l1_category_name: cached.l1_category_name || '',
      l2_category_name: cached.l2_category_name || '',
      l1_category_id: String(cached.l1_category_id || ''),
      l2_category_id: String(cached.l2_category_id || ''),
      mrp: pricing.mrp,
      discount_on_mrp: pricing.discount_on_mrp,
      total_payable: pricing.total_payable,
      in_stock: variantRow ? !!variantRow.in_stock : (cached.in_stock !== undefined ? !!cached.in_stock : true),
      color: color,
      fit: cached.fit || '',
      sleeve: cached.sleeve || '',
      material: cached.material || '',
      gender: cached.gender || '',
      size: (variantRow && variantRow.size) || cached.size || item.variant_title || '',
      quantity: Number(item.quantity) || 1
    };
  }

  function cartItemNeedsAnalyticsEnrichment(item) {
    item = item || {};
    var shopifyProductId = String(item.product_id || '');
    var handle = String(item.handle || '').trim();

    if (!shopifyProductId && !handle) {
      return false;
    }

    var cached = weGetProductContext(shopifyProductId);

    if (!String(cached.product_id || '').trim()) {
      return !!handle;
    }

    var variantRow = findVariantRow(cached.variants, item.variant_id);

    if (variantRow && String(variantRow.variant_id || '').trim()) {
      return false;
    }

    return !!handle;
  }

  function enrichCartItemsSequential(items) {
    items = items || [];
    var index = 0;
    var enrichOptions = {
      section: 'Cart',
      view_type: 'normal'
    };

    function step() {
      if (index >= items.length) {
        return Promise.resolve();
      }

      var item = items[index];
      index += 1;
      var shopifyProductId = String(item.product_id || '');
      var handle = String(item.handle || '').trim();
      var fetchPromise = null;

      if (!cartItemNeedsAnalyticsEnrichment(item)) {
        return step();
      }

      if (handle && shopifyProductId) {
        fetchPromise = weFetchAndCacheProductAnalytics(handle, shopifyProductId, enrichOptions);
      } else if (handle) {
        fetchPromise = weFetchProductAnalyticsByHandle(handle, enrichOptions);
      }

      if (!fetchPromise) {
        return step();
      }

      return fetchPromise.catch(function () {}).then(step);
    }

    return Promise.race([
      step(),
      new Promise(function (resolve) {
        setTimeout(resolve, WISHLIST_ENRICH_TIMEOUT_MS);
      })
    ]);
  }

  function publishEnrichedCartSummary(eventName, cart, meta) {
    cart = cart || {};
    meta = meta || {};

    enrichCartItemsSequential(cart.items).then(function () {
      if (typeof Shopify === 'undefined' || !Shopify.analytics || !Shopify.analytics.publish) {
        return;
      }

      if (!Array.isArray(cart.items)) {
        return;
      }

      var payload = buildCartSummaryFromCart(cart, findChangedCartLine(cart));

      if (meta.action) {
        payload.action = meta.action;
      }

      Shopify.analytics.publish(eventName, payload);
    });
  }

  var lastCartLinesByKey = {};

  function snapshotCartLines(cart) {
    var map = {};
    var items = (cart && cart.items) || [];
    var i;
    var item;
    var key;

    for (i = 0; i < items.length; i += 1) {
      item = items[i];
      key = String(item.key || item.variant_id || item.id || i);
      map[key] = item;
    }

    return map;
  }

  function findChangedCartLine(cart) {
    var items = (cart && cart.items) || [];
    var next = snapshotCartLines(cart);
    var i;
    var item;
    var key;
    var prev;
    var changed = null;

    for (i = 0; i < items.length; i += 1) {
      item = items[i];
      key = String(item.key || item.variant_id || item.id || i);
      prev = lastCartLinesByKey[key];

      if (!prev || Number(prev.quantity) !== Number(item.quantity)) {
        changed = item;
        break;
      }
    }

    if (!changed) {
      for (key in lastCartLinesByKey) {
        if (!Object.prototype.hasOwnProperty.call(lastCartLinesByKey, key)) {
          continue;
        }

        if (!next[key]) {
          changed = lastCartLinesByKey[key];
          break;
        }
      }
    }

    lastCartLinesByKey = next;
    return changed || items[0] || null;
  }

  function getCheckoutItemsCount(details, fallback) {
    var total = 0;

    (details || []).forEach(function (item) {
      total += Number(item.quantity) || 1;
    });

    if (total) {
      return total;
    }

    return Number(fallback) || 0;
  }

  function getCartDiscountBreakdown(cart) {
    cart = cart || {};
    var apps = cart.cart_level_discount_applications || [];
    var couponNames = [];
    var appCouponValue = 0;
    var promoNames = [];
    var appPromoValue = 0;
    var allocationCouponValue = 0;
    var allocationPromoValue = 0;
    var index;

    for (index = 0; index < apps.length; index += 1) {
      var app = apps[index];
      var title = app.title || '';
      var amount = centsToAmount(app.total_allocated_amount || 0);
      var type = String(app.type || '').toLowerCase();

      if (type === 'discount_code' || type === 'code') {
        if (title) {
          couponNames.push(title);
        }
        appCouponValue += amount;
      } else {
        if (title) {
          promoNames.push(title);
        }
        appPromoValue += amount;
      }
    }

    (cart.items || []).forEach(function (item) {
      var allocations = item.line_level_discount_allocations || item.discount_allocations || [];

      allocations.forEach(function (allocation) {
        var discountApp = allocation.discount_application || allocation.discountApplication || {};
        var value = centsToAmount(allocation.amount || 0);
        var discountType = String(discountApp.type || '').toLowerCase();
        var discountTitle = discountApp.title || '';

        if (discountType === 'discount_code' || discountType === 'code') {
          if (discountTitle && couponNames.indexOf(discountTitle) === -1) {
            couponNames.push(discountTitle);
          }
          allocationCouponValue += value;
        } else {
          if (discountTitle && promoNames.indexOf(discountTitle) === -1) {
            promoNames.push(discountTitle);
          }
          allocationPromoValue += value;
        }
      });
    });

    var couponValue = allocationCouponValue > 0 ? allocationCouponValue : appCouponValue;
    var promoValue = allocationPromoValue > 0 ? allocationPromoValue : appPromoValue;
    var totalDiscount = centsToAmount(cart.total_discount || 0);

    if (totalDiscount > 0 && couponValue === 0 && promoValue === 0) {
      if (promoNames.length) {
        promoValue = totalDiscount;
      } else if (couponNames.length) {
        couponValue = totalDiscount;
      } else {
        promoValue = totalDiscount;
      }
    }

    return {
      coupon_name: couponNames.join(', '),
      coupon_value: couponValue,
      promotion_name: promoNames.join(', '),
      promotion_value: promoValue
    };
  }

  function buildCheckoutPayloadFromCart(cart) {
    cart = cart || {};
    var items = cart.items || [];
    var productDetails = items.map(mapCartLineForCheckout);
    var discounts = getCartDiscountBreakdown(cart);
    var subtotal = centsToAmount(cart.items_subtotal_price);
    var totalPayable = centsToAmount(cart.total_price);
    var tax = 0;

    if (cart.total_tax != null && cart.total_tax !== '') {
      tax = centsToAmount(cart.total_tax);
    } else if (totalPayable > subtotal) {
      tax = totalPayable - subtotal;
    }

    var payload = {
      cart_id: String(cart.token || ''),
      total_items_in_cart: getCheckoutItemsCount(productDetails, cart.item_count),
      subtotal: subtotal,
      tax: tax,
      total_payable: totalPayable,
      coupon_name: discounts.coupon_name,
      coupon_value: discounts.coupon_value,
      promotion_name: discounts.promotion_name,
      promotion_value: discounts.promotion_value,
      checkout_url: '',
      product_details: productDetails
    };

    weApplyAggregatedProductFields(payload, productDetails);
    return payload;
  }

  function publishCheckoutInitiatedFromCart() {
    if (typeof Shopify === 'undefined' || !Shopify.analytics || !Shopify.analytics.publish) {
      return;
    }

    fetch((Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart.js')
        .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        Shopify.analytics.publish('bestseller:checkout_initiated', buildCheckoutPayloadFromCart(cart));
      })
      .catch(function () {});
  }

  function buildCartSummaryFromCart(cart, changedLine) {
    cart = cart || {};
    var items = cart.items || [];
    var productDetails = items.map(mapCartLineForCheckout);
    var subtotal = centsToAmount(cart.items_subtotal_price);
    var totalPayable = centsToAmount(cart.total_price);
    var tax = 0;
    var payload;

    if (cart.total_tax != null && cart.total_tax !== '') {
      tax = centsToAmount(cart.total_tax);
    } else if (totalPayable > subtotal) {
      tax = totalPayable - subtotal;
    }

    payload = {
      total_items_in_cart: Number(cart.item_count) || 0,
      subtotal: subtotal,
      tax: tax,
      total_payable: totalPayable,
      product_details: productDetails
    };

    weApplyAggregatedProductFields(payload, productDetails);
    return payload;
  }

  function publishCartAnalyticsEvent(eventName, cart) {
    if (!cart || !Array.isArray(cart.items)) {
      return;
    }

    publishEnrichedCartSummary(eventName, cart);
  }

  function fetchAndPublishCartAnalytics(eventName, meta) {
    meta = meta || {};

    fetch((Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart.js')
      .then(function (response) {
          return response.json();
        })
      .then(function (cart) {
        publishEnrichedCartSummary(eventName, cart, meta);
      })
      .catch(function () {});
  }

  var lastCartViewedAt = 0;

  function publishCartViewed(cart) {
    var now = Date.now();

    if (now - lastCartViewedAt < 2000) {
      return;
    }

    lastCartViewedAt = now;

    if (cart && Array.isArray(cart.items)) {
      publishCartAnalyticsEvent('bestseller:cart_viewed', cart);
      return;
    }

    fetchAndPublishCartAnalytics('bestseller:cart_viewed');
  }

  function getCartActionFromBaseEvent(baseEvent) {
    if (baseEvent === 'variant:add') {
      return 'add';
    }

    if (baseEvent === 'line-item:change') {
      return 'update';
    }

    return '';
  }

  document.addEventListener('cart:change', function (event) {
    var detail = event.detail || {};
    var cart = detail.cart;
    var action = getCartActionFromBaseEvent(detail.baseEvent);

    if (!cart || !Array.isArray(cart.items)) {
      fetchAndPublishCartAnalytics('bestseller:cart_updated', action ? { action: action } : {});
      return;
    }

    publishEnrichedCartSummary('bestseller:cart_updated', cart, action ? { action: action } : {});
  });

  window.addEventListener('view_cart', function () {
    publishCartViewed();
  });

  function initCartPageViewTracking() {
    var path = window.location.pathname;

    if (path !== '/cart' && path.indexOf('/cart/') !== 0) {
      return;
    }

    setTimeout(function () {
      publishCartViewed();
    }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartPageViewTracking);
  } else {
    initCartPageViewTracking();
  }

  document.addEventListener(
    'click',
    function (event) {
      var target = event.target.closest('button[name="checkout"], input[name="checkout"], a[href*="/checkout"]');

      if (!target) {
        return;
      }

      if (target.tagName === 'A' && target.href && target.href.indexOf('/checkout') === -1) {
        return;
      }

      publishCheckoutInitiatedFromCart();
    },
    true
  );
})();

(function () {
  var lastProductSearchedKey = '';

  function publishProductSearchedEvent(payload) {
    if (typeof Shopify === 'undefined' || !Shopify.analytics || !Shopify.analytics.publish) {
      return;
    }

    Shopify.analytics.publish('bestseller:product_searched', payload);
  }

  function getSearchTermFromUrl() {
    try {
      var params = new URLSearchParams(window.location.search);
      return (params.get('q') || params.get('query') || '').trim();
    } catch (error) {
      return '';
    }
  }

  function getProductCountFromTitle() {
    var title = document.title || '';
    var match = title.match(/(\d+)\s+results?\s+found/i);

    if (!match) {
      return null;
    }

    return parseInt(match[1], 10);
  }

  function isSearchPage() {
    var path = window.location.pathname;
    return path === '/search' || path.indexOf('/search/') === 0;
  }

  function shouldSkipProductSearched(searchTerm) {
    var key = String(searchTerm).toLowerCase();

    if (lastProductSearchedKey === key) {
      return true;
    }

    lastProductSearchedKey = key;
    return false;
  }

  function publishProductSearchedFromSearchPage() {
    if (!isSearchPage()) {
      return false;
    }

    var searchTerm = getSearchTermFromUrl();
    var productCount = getProductCountFromTitle();

    if (!searchTerm || productCount === null || isNaN(productCount)) {
      return false;
    }

    if (shouldSkipProductSearched(searchTerm)) {
      return true;
    }

    publishProductSearchedEvent({
      search_term: searchTerm,
      product_count: productCount
    });

    return true;
  }

  function initSearchPageTracking() {
    if (!isSearchPage()) {
      return;
    }

    if (publishProductSearchedFromSearchPage()) {
      return;
    }

    var attempts = 0;
    var interval = window.setInterval(function () {
      attempts += 1;

      if (publishProductSearchedFromSearchPage() || attempts >= 8) {
        window.clearInterval(interval);
      }
    }, 400);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSearchPageTracking);
  } else {
    initSearchPageTracking();
  }
})();

(function () {
  var PRODUCT_CACHE_PREFIX = 'we_product_ctx_';
  var lastProductViewedKey = '';
  var lastProductViewedAt = 0;

  function publishAnalyticsEvent(eventName, payload) {
    if (typeof Shopify === 'undefined' || !Shopify.analytics || !Shopify.analytics.publish) {
      return;
    }

    Shopify.analytics.publish(eventName, payload);
  }

  function resolveProductViewSection(explicitSection, basePayload) {
    if (explicitSection) {
      return explicitSection;
    }

    if (basePayload && basePayload.section) {
      return basePayload.section;
    }

    var path = window.location.pathname;

    if (path.indexOf('/products/') !== -1) {
      var ref = document.referrer || '';

      try {
        var refUrl = new URL(ref);

        if (refUrl.hostname === window.location.hostname) {
          if (refUrl.pathname.indexOf('/collections/') !== -1) {
            return 'PLP';
          }

          if (refUrl.pathname === '/' || refUrl.pathname === '') {
            return 'Home';
          }
        }
      } catch (error) {
        /* ignore */
      }

      return 'PDP';
    }

    return 'PLP';
  }

  function getCartItemCount(callback) {
    var cartCountNode = document.querySelector('cart-count');

    if (cartCountNode) {
      var domCount = parseInt(String(cartCountNode.textContent || '').trim(), 10);

      if (!isNaN(domCount)) {
        callback(domCount);
        return;
      }
    }

    var root = typeof Shopify !== 'undefined' && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';

    fetch(root + 'cart.js')
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        callback(Number(cart.item_count) || 0);
      })
      .catch(function () {
        callback(0);
      });
  }

  function weGetLastCategoryContext() {
    try {
      var raw = sessionStorage.getItem('we_last_category_ctx');
      return raw ? JSON.parse(raw) : null;
    } catch (error) {
      return null;
    }
  }

  function weShouldApplySessionCategoryContext() {
    if (window.location.pathname.indexOf('/collections/') !== -1) {
      return false;
    }

    try {
      var refUrl = new URL(document.referrer || '', window.location.origin);
      return refUrl.pathname.indexOf('/collections/') !== -1;
    } catch (error) {
      return false;
    }
  }

  function weApplySessionCategoryContext(payload) {
    payload = payload || {};

    if (!weShouldApplySessionCategoryContext()) {
      return payload;
    }

    var ctx = weGetLastCategoryContext();
    if (!ctx) {
      return payload;
    }

    if (ctx.l1_category_name) {
      payload.l1_category_name = ctx.l1_category_name;
    }

    if (ctx.l2_category_name) {
      payload.l2_category_name = ctx.l2_category_name;
    }

    if (ctx.l1_category_id) {
      payload.l1_category_id = String(ctx.l1_category_id);
    }

    if (ctx.l2_category_id) {
      payload.l2_category_id = String(ctx.l2_category_id);
    }

    return payload;
  }

  function buildProductViewedPayload(basePayload, variantId, options) {
    basePayload = basePayload || {};
    options = options || {};

    var variantRow = weFindVariantRow(basePayload.variants, variantId);

    if (!variantRow) {
      variantRow = (basePayload.variants || [])[0] || {};
    }

    return weApplySessionCategoryContext({
      product_id: String(basePayload.product_id || ''),
      shopify_product_id: String(basePayload.shopify_product_id || ''),
      shopify_variant_id: String(variantRow.shopify_variant_id || variantId || ''),
      product_name: basePayload.product_name || '',
      image_url: weNormalizeImageUrl(basePayload.image_url),
      sub_brand_name: weResolveSubBrandName(basePayload.gender),
      l1_category_name: basePayload.l1_category_name || '',
      l2_category_name: basePayload.l2_category_name || '',
      l1_category_id: String(basePayload.l1_category_id || ''),
      l2_category_id: String(basePayload.l2_category_id || ''),
      section: resolveProductViewSection(options.section, basePayload),
      view_type: options.view_type || basePayload.view_type || 'normal',
      variant_id: String(variantRow.variant_id || variantId || ''),
      mrp: Number(variantRow.mrp) || 0,
      total_payable: Number(variantRow.total_payable) || 0,
      discount_on_mrp: Number(variantRow.discount_on_mrp) || 0,
      in_stock: !!variantRow.in_stock,
      size: variantRow.size || '',
      color: variantRow.color || basePayload.default_color || '',
      fit: basePayload.fit || '',
      sleeve: basePayload.sleeve || '',
      material: basePayload.material || '',
      gender: basePayload.gender || '',
      total_items_in_cart: Number(options.total_items_in_cart) || 0,
      variants: basePayload.variants || []
    });
  }

  function shouldSkipProductViewed(payload) {
    var key = String(payload.product_id) + ':' + String(payload.section);
    var now = Date.now();

    if (lastProductViewedKey === key && now - lastProductViewedAt < 2000) {
      return true;
    }

    lastProductViewedKey = key;
    lastProductViewedAt = now;
    return false;
  }

  window.__wePublishProductViewed = function (basePayload, variantId, options) {
    getCartItemCount(function (cartCount) {
      options = options || {};
      options.total_items_in_cart = cartCount;

      var payload = buildProductViewedPayload(basePayload, variantId, options);

      if (shouldSkipProductViewed(payload)) {
        return;
      }

      publishAnalyticsEvent('bestseller:product_viewed', payload);
      weCacheProductContext(payload);
    });
  };

  function publishQuickBuyProductViewed(card) {
    if (!card) {
      return;
    }

    var analyticsNode = card.querySelector('script.webengage-product-analytics');

    if (!analyticsNode) {
      return;
    }

    try {
      var basePayload = JSON.parse(analyticsNode.textContent || '{}');
      var variants = basePayload.variants || [];
      var variantRow = variants[0] || {};

      window.__weLastPlpAddContext = {
        section: basePayload.section || 'PLP',
        view_type: 'quick'
      };

      weEnrichAndCacheProductForCart(String(basePayload.shopify_product_id || ''), window.__weLastPlpAddContext);

      window.__wePublishProductViewed(basePayload, variantRow.shopify_variant_id || variantRow.variant_id, {
        section: basePayload.section || 'PLP',
        view_type: 'quick'
      });
    } catch (error) {
      /* ignore */
    }
  }

  document.addEventListener(
    'click',
    function (event) {
      var quickBuyButton = event.target.closest('.product-card__quick-add-button, .mosaic-card__quick-add');

      if (!quickBuyButton) {
        return;
      }

      publishQuickBuyProductViewed(quickBuyButton.closest('product-card'));
    },
    true
  );

  document.addEventListener(
    'click',
    function (event) {
      var directAddButton = event.target.closest('.product-card__quick-add-button, .mosaic-card__quick-add');

      if (!directAddButton || directAddButton.getAttribute('type') !== 'submit') {
        return;
      }

      var card = directAddButton.closest('product-card');

      if (!card) {
        return;
      }

      window.__weLastPlpAddContext = {
        section: 'PLP',
        view_type: 'normal'
      };

      try {
        var analyticsNode = card.querySelector('script.webengage-product-analytics');

        if (analyticsNode) {
          var basePayload = JSON.parse(analyticsNode.textContent || '{}');
          weEnrichAndCacheProductForCart(String(basePayload.shopify_product_id || ''), window.__weLastPlpAddContext);
        }
      } catch (error) {
        /* ignore */
      }
    },
    true
  );
})();



(function () {
  'use strict';

  var config = window.__MOBILE_LOGO_OVERLAY_CONFIG__ || null;
  if (!config) return;
  if (window.innerWidth > config.breakpoint) return;

  var overlay = document.querySelector('[data-mobile-logo-overlay]');
  var logoImage = overlay ? overlay.querySelector('[data-mobile-logo-image]') : null;
  if (!overlay || !logoImage) return;

  var activeSectionIds = new Set();
  var currentVariant = 'black';
  document.body.setAttribute('data-mobile-logo-overlay-variant', currentVariant);

  function readForceColor(startElement, sectionElement) {
    var el = startElement;
    while (el && el !== document.body) {
      var forced = (el.getAttribute && el.getAttribute('data-force-logo-color')) || '';
      if (forced === 'black' || forced === 'white') return forced;
      if (el === sectionElement) break;
      el = el.parentElement;
    }
    return null;
  }

  function readForceColorFromSelectedSlide(sectionElement) {
    if (!sectionElement) return null;
    var slide = sectionElement.querySelector('.slideshow__slide.is-selected[data-force-logo-color]');
    if (!slide) return null;
    var forced = slide.getAttribute('data-force-logo-color');
    return forced === 'black' || forced === 'white' ? forced : null;
  }

  function bindSlideshowCarouselListeners() {
    document.querySelectorAll('slideshow-carousel.slideshow').forEach(function (carousel) {
      if (carousel.dataset.mobileLogoBound === 'true') return;
      carousel.dataset.mobileLogoBound = 'true';
      carousel.addEventListener('carousel:change', queueUpdate);
      carousel.addEventListener('carousel:settle', queueUpdate);
    });
  }

  function pickSectionAtPoint(x, y) {
    var elementAtPoint = document.elementFromPoint(x, y);
    if (!elementAtPoint) return null;

    var section = elementAtPoint.closest('[id^="shopify-section-"]');
    if (section) return { section: section, element: elementAtPoint };

    var fallback = null;
    activeSectionIds.forEach(function (id) {
      var el = document.getElementById(id);
      if (!el) return;
      var rect = el.getBoundingClientRect();
      if (x >= rect.left && x <= rect.right && y >= rect.top && y <= rect.bottom) {
        fallback = el;
      }
    });

    return fallback ? { section: fallback, element: fallback } : null;
  }

  function setLogoVariant(nextVariant) {
    if (nextVariant !== 'black' && nextVariant !== 'white') return;
    document.body.setAttribute('data-mobile-logo-overlay-variant', nextVariant);
    if (nextVariant === currentVariant) return;

    var nextSrc = nextVariant === 'white' ? config.whiteLogo : config.blackLogo;
    if (!nextSrc) return;

    currentVariant = nextVariant;
    logoImage.classList.add('is-fading');

    window.setTimeout(function () {
      logoImage.src = nextSrc;
      logoImage.classList.remove('is-fading');
    }, 150);
  }

  var rafHandle = 0;
  function queueUpdate() {
    if (rafHandle) return;
    rafHandle = window.requestAnimationFrame(function () {
      rafHandle = 0;
      var x = Math.floor(window.innerWidth / 2);
      var y = Math.floor(window.innerHeight * 0.75);
      var sectionContext = pickSectionAtPoint(x, y);

      if (!sectionContext || !sectionContext.section) {
        overlay.classList.remove('is-visible');
        setLogoVariant('black');
        return;
      }

      var forcedColor = readForceColor(sectionContext.element, sectionContext.section);
      if (!forcedColor) {
        forcedColor = readForceColorFromSelectedSlide(sectionContext.section);
      }
      if (!forcedColor) {
        overlay.classList.remove('is-visible');
        setLogoVariant('black');
        return;
      }

      overlay.classList.add('is-visible');
      setLogoVariant(forcedColor);
    });
  }

  var sectionObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.target.id) return;
      if (entry.isIntersecting) {
        activeSectionIds.add(entry.target.id);
      } else {
        activeSectionIds.delete(entry.target.id);
      }
    });
    queueUpdate();
  }, {
    root: null,
    threshold: [0, 0.2, 0.5, 0.8, 1],
    rootMargin: '0px 0px -10% 0px'
  });

  document.querySelectorAll('main [id^="shopify-section-"]').forEach(function (section) {
    sectionObserver.observe(section);
  });

  bindSlideshowCarouselListeners();

  window.addEventListener('scroll', queueUpdate, { passive: true });
  window.addEventListener('resize', function () {
    if (window.innerWidth > config.breakpoint) {
      overlay.classList.remove('is-visible');
      return;
    }
    queueUpdate();
  }, { passive: true });

  window.addEventListener('shopify:section:load', function () {
    document.querySelectorAll('main [id^="shopify-section-"]').forEach(function (section) {
      sectionObserver.observe(section);
    });
    bindSlideshowCarouselListeners();
    sectionLuminanceCache.clear();
    queueUpdate();
  });

  queueUpdate();
})();

// -----------------------------------------------------------------------------
// CUSTOMER INVOICE LIST (ONLINE / OFFLINE)
// -----------------------------------------------------------------------------

document.addEventListener('DOMContentLoaded', function () {
  var invoiceSection = document.querySelector('.invoice-section[data-invoice-endpoint]');
  if (!invoiceSection) return;

  var phone = invoiceSection.getAttribute('data-invoice-phone') || '';
  var store = invoiceSection.getAttribute('data-invoice-store') || '';
  var endpoint = invoiceSection.getAttribute('data-invoice-endpoint') || '';

  if (!phone || !endpoint || !store) return;

  var cache = {
    online: null,
    offline: null
  };
  var currentType = 'online';

  var tabs = invoiceSection.querySelectorAll('.invoice-tab');
  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      var type = tab.getAttribute('data-invoice-type');
      if (!type || type === currentType) return;

      currentType = type;
      tabs.forEach(function (innerTab) {
        innerTab.classList.toggle('is-active', innerTab === tab);
      });

      loadInvoices(type);
    });
  });

  loadInvoices('online');

  function loadInvoices(type) {
    var tbody = invoiceSection.querySelector('.invoice-table-body');
    var errorEl = invoiceSection.querySelector('.invoice-error');
    var emptyMessageEl = invoiceSection.querySelector('.invoice-empty-message');
    var table = invoiceSection.querySelector('.invoice-table');
    if (!tbody || !errorEl) return;

    if (table) {
      table.classList.toggle('invoice-table--offline', type === 'offline');
    }

    errorEl.style.display = 'none';
    errorEl.textContent = '';
    if (emptyMessageEl) {
      emptyMessageEl.style.display = 'none';
      emptyMessageEl.textContent = '';
    }
    tbody.innerHTML =
      '<tr><td colspan="6">Loading ' + (type === 'online' ? 'website' : 'offline') + ' invoices&hellip;</td></tr>';

    if (cache[type]) {
      renderInvoices(cache[type], type);
      return;
    }

    try {
      var url = new URL(endpoint);
      url.searchParams.set('phone', phone);
      url.searchParams.set('store', store);
      url.searchParams.set('type', type);

      fetch(url.toString())
        .then(function (response) {
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          return response.json();
        })
        .then(function (data) {
          if (!data || data.success !== true || !Array.isArray(data.data)) {
            throw new Error('Unexpected API response');
          }

          cache[type] = data.data;
          renderInvoices(cache[type], type);
        })
        .catch(function (error) {
          console.error('Error fetching invoices', error);
          tbody.innerHTML = '';
          errorEl.textContent = 'Unable to load invoices at the moment. Please try again later.';
          errorEl.style.display = 'block';
          if (emptyMessageEl) {
            emptyMessageEl.style.display = 'none';
            emptyMessageEl.textContent = '';
          }
        });
    } catch (e) {
      console.error('Error building invoice URL', e);
    }
  }

  function renderInvoices(list, type) {
    var tbody = invoiceSection.querySelector('.invoice-table-body');
    var emptyMessageEl = invoiceSection.querySelector('.invoice-empty-message');
    if (!tbody) return;

    if (!list || list.length === 0) {
      var message =
        type === 'offline'
          ? 'You do not have any in-store purchases yet.'
          : 'You do not have any online orders yet.';

      tbody.innerHTML = '';

      if (emptyMessageEl) {
        emptyMessageEl.textContent = message;
        emptyMessageEl.style.display = 'block';
      }

      return;
    }

    tbody.innerHTML = '';

    if (emptyMessageEl) {
      emptyMessageEl.style.display = 'none';
      emptyMessageEl.textContent = '';
    }

    list.forEach(function (item) {
      var tr = document.createElement('tr');
      var orderNumber = item.salesOrderNumber || '';
      var invoiceNumber = item.invoiceNumber || '';
      var purchaseDate = formatInvoiceDate(item.purchaseDate);
      var amount = item.paidAmount || '';
      var invoiceDate = formatInvoiceDate(item.invoiceDate);
      var url = item.invoiceUrl || '';

      tr.innerHTML =
        '<td>' + escapeHtml(orderNumber) + '</td>' +
        '<td>' + escapeHtml(invoiceNumber) + '</td>' +
        '<td>' + escapeHtml(purchaseDate) + '</td>' +
        '<td>' + escapeHtml(amount) + '</td>' +
        '<td>' + escapeHtml(invoiceDate) + '</td>' +
        '<td class="text-end">' +
        (url
          ? '<a href="' + encodeURI(url) + '" target="_blank" rel="noopener" class="link-faded">View invoice</a>'
          : '') +
        '</td>';

      tbody.appendChild(tr);
    });
  }

  function formatInvoiceDate(raw) {
    if (!raw) return '';

    var value = String(raw).trim();
    var dotMatch = value.match(/^(\d{2})\.(\d{2})\.(\d{4})/);

    if (dotMatch) {
      return dotMatch[1] + '/' + dotMatch[2] + '/' + dotMatch[3];
    }

    var dashMatch = value.match(/^(\d{4})-(\d{2})-(\d{2})/);

    if (dashMatch) {
      return dashMatch[3] + '/' + dashMatch[2] + '/' + dashMatch[1];
    }

    var d = new Date(value);

    if (!isNaN(d.getTime())) {
      var dd = String(d.getDate()).padStart(2, '0');
      var mm = String(d.getMonth() + 1).padStart(2, '0');
      var yyyy = d.getFullYear();
      return dd + '/' + mm + '/' + yyyy;
    }

    return value;
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (char) {
      switch (char) {
        case '&':
          return '&amp;';
        case '<':
          return '&lt;';
        case '>':
          return '&gt;';
        case '"':
          return '&quot;';
        default:
          return '&#39;';
      }
    });
  }
});
